import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button, Modal, ModalBody, Text } from "@wojo/ui";
import React, { useId, useState } from "react";
import { FiCheck } from "react-icons/fi";

export const QuoteFlightsModal: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { productPage } = useI18n("productPage");
    const { global } = useI18n("global");
    const modalBtnLabel =
        productPage.tripBuilder.quote.flights.modalButtonLabel.l();
    const flightsHeader = global.flights.heading.l();
    const detailId = useId();

    if (!modalBtnLabel || !flightsHeader) {
        return null;
    }

    return (
        <>
            <Button
                variant="quiet"
                type="button"
                onClick={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "MODAL_OPENED",
                            modalId: "Flights Info",
                        },
                    });
                    setIsOpen(true);
                }}
            >
                {modalBtnLabel}{" "}
                <span className="visually-hidden">: {flightsHeader}</span>
            </Button>
            <Modal
                onCloseRequested={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "MODAL_CLOSED",
                            modalId: "Flights Info",
                        },
                    });
                    setIsOpen(false);
                }}
                isOpen={isOpen}
                accessibleTitle={flightsHeader}
            >
                <ModalBody>
                    <Text.Heading tag="h2" order="3">
                        {flightsHeader}
                    </Text.Heading>
                    <Text style={{ marginTop: "var(--g-spacing-sm" }}>
                        {global.flights.subheading.l()}
                    </Text>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "min-content 1fr",
                            gap: "var(--g-spacing-sm)",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            marginTop: "var(--g-spacing-xl)",
                        }}
                    >
                        {global.flights.details.map((detail, index) => {
                            return (
                                <React.Fragment key={`${detailId}-${index}`}>
                                    <FiCheck
                                        aria-hidden
                                        style={{
                                            height: 20,
                                            width: 20,
                                            marginTop: "var(--g-spacing-xxs)",
                                        }}
                                    />
                                    <div>
                                        <Text.Body emphasis="2" tag="h3">
                                            {detail.label.l()}
                                        </Text.Body>
                                        <Text.Body
                                            style={{
                                                marginTop:
                                                    "var(--g-spacing-xxs)",
                                            }}
                                        >
                                            {detail.value}
                                        </Text.Body>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};
